// La rangée des catégories flotte hors du flux, par-dessus le contenu de la page. Les pages doivent
// donc réserver cette hauteur en haut de leur première bande, sans quoi leur texte passerait
// dessous. La valeur couvre la pastille (44px de contenu + 2 × 8px de rembourrage) et l'espace qui
// la sépare de la barre du dessus.
export const FLOATING_CATEGORY_NAV_HEIGHT = 84;
